// @flow strict
import type { Grade, State } from './state-list.js';

export function getPartner(data: State[], selectedPartnerId: string): ?State {
  for (let i = 0; i < data.length; i++) {
    if (data[i].stateId === selectedPartnerId) {
      return data[i];
    }
  }
  return null;
}

export function getGrade(grades: Grade[], selectedGradeId: string): ?Grade {
  for (let i = 0; i < grades.length; i++) {
    if (grades[i].gradeId === selectedGradeId) {
      return grades[i];
    }
  }
  return null;
}
